import { useFormContext } from "components/Form";
import { Radio as RadioComponent, RadioProps } from "components/Radio";
import { Controller } from "react-hook-form";
import * as S from "./styles";

interface HFRadio extends RadioProps {
  name: string;
  error?: boolean;
  helperText?: string;
}

export function Radio(props: HFRadio) {
  const {
    methodsForm: { control },
  } = useFormContext();

  return (
    <S.Container>
      <Controller
        name={props.name}
        control={control}
        defaultValue=""
        render={({ field }) => {
          const { ref, value, ...fieldProps } = field;
          return (
            <RadioComponent
              {...props}
              {...fieldProps}
              value={value || ""}
              ref={ref}
            />
          );
        }}
      />
    </S.Container>
  );
}
